import { render } from "./SearchParams.vue?vue&type=template&id=60b0732e"
import script from "./SearchParams.vue?vue&type=script&lang=js"
export * from "./SearchParams.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__